import React from 'react';
const Source = (props) => {
    const { src, src2dpr, mimeType } = props;
    const srcSet = src && src2dpr ? `${src} 1x, ${src2dpr} 2x` : src;
    return React.createElement("source", { srcSet: srcSet, type: mimeType });
};
export const Picture = (props) => {
    const { alt, className } = props;
    const [src, src2dpr] = props.src;
    const [webp, webp2dpr] = props.webp || [];
    const fallbackImage = src2dpr || src;
    return (React.createElement("picture", null,
        props.webp && React.createElement(Source, { mimeType: "image/webp", src: webp, src2dpr: webp2dpr }),
        React.createElement(Source, { src: src, src2dpr: src2dpr }),
        React.createElement("img", { src: fallbackImage, alt: alt, className: className })));
};
//# sourceMappingURL=picture.js.map